module.exports = __webpack_public_path__ + "static/media/olive-oil.8c017d10.png";